<template>
  <el-card class="card" :class="{ 'show-gap': showGap, 'not-show-gap': !showGap }" :body-style="{ ...bodyStyles }" v-bind="{...$attrs}" @click.native="handleClick">
    <template #header v-if="cardTitle">
      <div class="card-header">
        <el-badge :value="count" :max="99" :hidden="!count">
          <div class="card-title">
            <el-image :class="hasPermission? '' : 'icon-no-permission'" style="width: 20px; height: 20px; margin-right: 10px;" :src="getTitleImage" fit="cover" v-if="titleImage"></el-image>
            <span class="title">{{ $t(cardTitle) }}</span>
          </div>
        </el-badge>
        <div class="card-operation">
          <slot name="ope" />
        </div>
      </div>
    </template>
    <slot />
  </el-card>
</template>

<script>
  export default {
    name: "Card",
    props: {
      cardTitle: {
        type: String,
        default: ''
      },
      titleImage: {
        type: String,
        default: ''
      },
      showGap: {
        type: Boolean,
        default: true
      },
      count: {
        type: [String, Number],
        default: 0
      },
      bodyStyle: {
        type: Boolean,
        default() {
          return  {}
        }
      },
      hasPermission: {
        type: Boolean,
        default() {
          return  true
        }
      }
    },
    methods: {
      handleClick() {
        this.$emit('click')
      }
    },
    computed: {
      getTitleImage() {
        return this.titleImage ? require(`@/assets/img/icon/${ this.titleImage }.png`) : ''
      },
      bodyStyles() {
        return {
          ...this.bodyStyle,
          height: !!this.cardTitle ? 'calc(100% - 51px)' : '100%',
          padding: '12px 20px',
          boxSizing: 'border-box'
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .card {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    pointer-events: auto;
    &.show-gap {
      &+.show-gap {
        margin-left: 15px;
      }
    }
    &.not-show-gap {
      -webkit-border-radius: 0;
      -moz-border-radius: 0;
      border-radius: 0;
      -webkit-box-shadow: none;
      -moz-box-shadow: none;
      box-shadow: none;
      border: none;
      border-left: 1px solid #EBEEF5;
    }
    .card-header {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .card-title {
        font-size: 15px;
        display: flex;
        align-items: center;
        .icon-no-permission {
          filter: grayscale(100%) brightness(125%);
        }
      }
    }
    .card-operation {
      height: 100%;
      display: flex;
      align-items: center;
      cursor: pointer;
      ::v-deep .operation-icon {
        font-size: 20px;
      }
      ::v-deep .operation-item {
        width: 96px;
        &.el-date-editor {
          .el-input__inner {
            -webkit-border-radius: 16px;
            -moz-border-radius: 16px;
            border-radius: 16px;
          }
        }
      }
    }
  }
</style>
